<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert')">Carl Von
                        Schubert
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/egon-muller')">Egon Müller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/jj-prum')">J.J. Prüm
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/peter-lauer')">Peter Lauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/van-volxem')">Van Volxem
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken')">
                        Weingut Forstmeister Geltz Zilliken
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch')">Wwe. Dr. H. Thanisch, Erben Thanisch</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Wwe. Dr. H. Thanisch, Erben Thanisch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Ci sono molte regioni vinicole per gli investitori che vogliono guardare oltre Bordeaux. Solo la Francia ha a
                        almeno 11, l'Italia ne ha almeno due maggiori con tante altre eccellenti regioni minori, e
                        in tutto il mondo, le opportunità sono mature e abbondanti. Ma una regione che viene spesso trascurata è la Germania
                        Mosella. Conosciamo tutti Egon Muller e J.J. Prum ormai, ma permetteteci di presentarvi
                        al dottor H. Thanisch, e cambieremo per sempre il modo in cui vedete il Riesling.
                    </div>

                    <div class="howto-title2">Il potere delle ragazze</div>
                    <div class="howto-text">
                        Una cantina storica che risale a quasi 400 anni fa, Wwe. Dr H. Thanisch è soprattutto una storia
                        di donne forti. Il dottor Hugo Thanisch morì improvvisamente nel 1895, lasciando la vedova trentenne (sua
                        “witwe”, abbreviato in “wwe”) Katharina, con tre figli piccoli e una tenuta da gestire.
                        Tuttavia, per non fallire di fronte alle avversità, Katharina ha affrontato la sfida in modo ammirevole,
                        e sotto il suo mandato, la tenuta divenne uno dei membri fondatori dell'Associazione dei tedeschi
                        Produttori di Vino di Qualità (VDP) nel 1910. Da allora l'azienda si è tramandata attraverso 11 generazioni
                        e oggi Sofia Thanisch (pronipote di Katharina e Hugo e quarta donna) è al
                        timone della tenuta di 6,5 ettari. Le due figlie di Sofia sembrano destinate a continuare la tradizione.
                    </div>

                    <div class="howto-title2">Più Mosella, per favore!</div>
                    <div class="howto-text">
                        Immersi nel miglior terroir della Mosella, i vigneti del Wwe Dr. H. Thanisch corrono lungo una parcella rettilinea di
                        terreno adiacente al fiume. La vicinanza all'acqua, insieme alla posizione esposta a sud e
                        un terreno superbo crea la santa trinità per le eccezionali uve Riesling. Così si definiscono i vini
                        dalle loro caratteristiche uniche: gusto delicato, sofisticata eleganza e leggerezza. Del
                        otto vini Riesling prodotti, il più famoso è probabilmente del grande “Bernkasteler Doctor”
                        vigneto. Questi vini squisiti sono molto apprezzati sia dagli intenditori che dagli investitori di vino
                        la loro bellezza e complessità, che li rende alcuni dei vini più ricercati dell'intero
                        Regione Mosella-Saar-Ruwer. Tuttavia, i vini Doctor a volte possono essere fraintesi. Quando assaggiato
                        la loro giovinezza, possono sembrare un po' noiosi, e molti critici ritengono che non abbia senso aprire
                        uno in su prima di almeno dieci anni di invecchiamento. L'ironia qui è che con una produzione così bassa
                        (4.000 bottiglie all'anno) e il tempo richiesto in cantina, il vino sta diventando sempre più difficile
                        Trovare.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Nel 1921, Thanisch ha fatto la storia producendo il primissimo Trockenbeerenauslese sul
                                Mosella. Prodotta solo nelle annate appropriate, una bottiglia come quella dell'annata 2006 è di richiamo
                                oltre € 660 nel 2019.
                            </li>
                            <li>Weinguide Deutschland 2019 ha nominato il Bernkasteler Doctor Riesling Spätlese 2017 di Wwe Dr H Thanisch il "Miglior Riesling Spätlese nel VDP", assegnando 97 punti, mentre Mosel Fine Wines ha assegnato a questa particolare annata 95 punti.
                            </li>
                            <li>A causa della grandine e del gelo, la resa del 2017 è stata inferiore di quasi il 50% rispetto a quella del 2016.
                                la combinazione di una maggiore concentrazione e di rese inferiori rende il più eccellente
                                Bernkasteler Doctor Riesling Auslese. Notando “Un grande, grande Auslese. Bere 2027-2100”
                                John Gilman ha ritenuto che questa particolare annata valesse i suoi 96 punti.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Wwe. Dr. H. Thanisch, Erben Thanisch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Es gibt viele Weinregionen für Investoren, die über Bordeaux hinausblicken möchten. Allein Frankreich hat es geschafft
                        mindestens 11, Italien hat mindestens zwei große Regionen mit vielen anderen hervorragenden Nebenregionen, und
                        Weltweit sind die Chancen reif und vielfältig. Aber eine Region, die oft übersehen wird, ist die Deutschlands
                        Mosel. Wir alle kennen Egon Müller und J.J. Prum, aber erlauben Sie uns, Sie vorzustellen
                        an Dr. H. Thanisch, und wir werden die Art und Weise, wie Sie Riesling sehen, für immer verändern.
                    </div>

                    <div class="howto-title2">Frauenpower</div>
                    <div class="howto-text">
                        Wwe ist ein historisches Weingut mit einer fast 400-jährigen Geschichte. Dr. H. Thanisch ist vor allem eine Geschichte
                        von starken Frauen. Dr. Hugo Thanisch starb unerwartet im Jahr 1895 und hinterließ seine 30-jährige Witwe (seine).
                        „witwe“, abgekürzt „wwe“) Katharina, mit drei kleinen Kindern und einem Anwesen, das sie führen muss.
                        Katharina war jedoch nicht diejenige, die angesichts von Widrigkeiten scheiterte, und meisterte die Herausforderung bewundernswert.
                        und unter ihrer Amtszeit wurde das Anwesen eines der Gründungsmitglieder des Deutschen Verbandes
                        Qualitätsweinproduzenten (VDP) im Jahr 1910. Das Weingut wird seitdem über 11 Generationen weitergegeben
                        und heute ist Sofia Thanisch (Katharinas und Hugos Urenkelin und vierte Frau) im
                        Leiter des 6,5 Hektar großen Anwesens. Sofias zwei Töchter werden die Tradition voraussichtlich fortsetzen.
                    </div>

                    <div class="howto-title2">Mehr Mosel bitte!</div>
                    <div class="howto-text">
                        Die Weinberge von Wwe Dr. H. Thanisch liegen im erstklassigen Mosel-Terroir und erstrecken sich entlang einer geraden Parzelle
                        Land neben dem Fluss. Die Nähe zum Wasser, zusammen mit der Südlage und
                        Hervorragender Boden schafft die heilige Dreifaltigkeit für hervorragende Riesling-Trauben. Dadurch werden die Weine definiert
                        durch ihre einzigartigen Eigenschaften: delikater Geschmack, raffinierte Eleganz und Leichtigkeit. Des
                        Es werden acht Rieslingweine produziert, der berühmteste stammt wohl vom großen „Bernkasteler Doktor“
                        Weinberg. Diese erlesenen Weine werden von Kennern und Weininvestoren gleichermaßen geschätzt
                        Ihre Schönheit und Komplexität machen sie zu den begehrtesten Weinen überhaupt
                        Region Mosel-Saar-Ruwer. Allerdings können Doktorweine manchmal falsch interpretiert werden. Bei der Verkostung
                        Aufgrund ihrer Jugend können sie ein wenig langweilig wirken, und viele Kritiker glauben, dass es keinen Sinn macht, sie zu eröffnen
                        einer vor mindestens zehnjähriger Reifung. Die Ironie dabei ist, dass die Produktion so gering ist
                        (4.000 Flaschen pro Jahr) und der erforderlichen Kellerzeit wird es immer schwieriger, den Wein zu produzieren
                        finden.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Im Jahr 1921 schrieb Thanisch Geschichte, als er die allererste Trockenbeerenauslese auf dem Weingut produzierte
                                Mosel. Nur in geeigneten Jahren hergestellt, eine Flasche wie der Jahrgang 2006 ist bezaubernd
                                ab 660 € im Jahr 2019.
                            </li>
                            <li>Weinguide Deutschland 2019 zeichnete die Bernkasteler Doctor Riesling Spätlese 2017 von Wwe Dr.
                            </li>
                            <li>Aufgrund von Hagel und Frost war der Ertrag 2017 fast 50 % geringer als der von 2016. Die
                                Die Kombination aus höherer Konzentration und geringeren Erträgen sorgt für ein hervorragendes Ergebnis
                                Bernkasteler Doctor Riesling Auslese. Anmerkung: „Eine großartige, großartige Auslese. Trinken 2027-2100“
                                John Gilman hielt diesen besonderen Jahrgang für seine 96 Punkte wert.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Wwe. Dr. H. Thanisch, Erben Thanisch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il existe de nombreuses régions viticoles pour les investisseurs qui veulent regarder au-delà de Bordeaux. La France seule a au
                        moins 11, l'Italie en a au moins deux grandes avec de nombreuses autres excellentes régions mineures, et
                        dans le monde entier, les opportunités sont mûres et nombreuses. Mais une région souvent négligée est l'Allemagne
                        Moselle. Nous connaissons tous Egon Muller et J.J. Prum maintenant, mais permettez-nous de vous présenter
                        au Dr H. Thanisch, et nous changerons à jamais votre façon de voir le Riesling.
                    </div>

                    <div class="howto-title2">Le pouvoir des filles</div>
                    <div class="howto-text">
                        Un domaine viticole historique qui remonte à près de 400 ans, Wwe. Dr H. Thanisch est avant tout une histoire
                        de femmes fortes. Le Dr Hugo Thanisch est décédé subitement en 1895, laissant sa veuve de 30 ans (sa
                        "witwe", abrégé en "wwe") Katharina, avec trois jeunes enfants et un domaine à gérer.
                        Cependant, n'étant pas du genre à échouer face à l'adversité, Katharina a admirablement relevé le défi,
                        et sous son mandat, le domaine est devenu l'un des membres fondateurs de l'Association des Allemands
                        Producteurs de Vins de Qualité (VDP) en 1910. Le domaine s'est depuis transmis sur 11 générations
                        et aujourd'hui Sofia Thanisch (arrière-petite-fille de Katharina et Hugo et 4e femelle) est au
                        aux commandes du domaine de 6,5 hectares. Les deux filles de Sofia semblent prêtes à perpétuer la tradition.
                    </div>

                    <div class="howto-title2">Plus de Moselle s'il vous plaît!</div>
                    <div class="howto-text">
                        Situés sur le terroir de la Moselle, les vignobles de la Wwe Dr. H. Thanisch s'étendent le long d'une parcelle droite de
                        terrain adjacent à la rivière. La proximité de l'eau, ainsi que l'exposition plein sud et
                        un sol superbe crée la sainte trinité pour des raisins Riesling exceptionnels. Ainsi les vins sont définis
                        par leurs caractéristiques uniques : goût délicat, élégance raffinée et légèreté. De la
                        huit vins de Riesling produits, le plus célèbre est probablement celui du grand "Bernkasteler Doctor"
                        vignoble. Ces vins exquis sont très prisés par les connaisseurs et les investisseurs en vins pour leur
                        leur beauté et leur complexité, ce qui en fait l'un des vins les plus recherchés de l'ensemble
                        Région Moselle-Sarre-Ruwer. Cependant, les vins Doctor peuvent parfois être mal interprétés. Lorsqu'il est dégusté dans
                        leur jeunesse, ils peuvent sembler un peu ternes, et de nombreux critiques pensent qu'il est inutile d'ouvrir
                        une montée avant au moins dix ans de vieillissement. L'ironie ici est qu'avec une si faible production
                        (4 000 bouteilles annuelles) et le temps de cave requis, le vin devient de plus en plus difficile à
                        trouver.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>En 1921, Thanisch est entré dans l'histoire en produisant le tout premier Trockenbeerenauslese sur le
                                Moselle. Fabriqué uniquement dans les années appropriées, une bouteille comme le millésime 2006 va chercher
                                plus de 660 € en 2019.
                            </li>
                            <li>Weinguide Deutschland 2019 a nommé le Bernkasteler Doctor Riesling Spätlese 2017 de la Wwe Dr H Thanisch le «Meilleur Riesling Spätlese du VDP», attribuant 97 points, tandis que Mosel Fine Wines a attribué 95 points à ce millésime particulier.
                            </li>
                            <li>En raison de la grêle et du gel, le rendement de 2017 a été inférieur de près de 50% à celui de 2016.
                                la combinaison d'une concentration plus élevée et de rendements plus faibles en fait un excellent
                                Bernkasteler Docteur Riesling Auslese. Notant « Un grand, grand Auslese. Boire 2027-2100 ”
                                John Gilman a estimé que ce millésime particulier valait ses 96 points.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Wwe. Dr. H. Thanisch, Erben Thanisch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        There are many wine regions for investors who want to look beyond Bordeaux. France alone has at
                        least 11, Italy has at least two major ones with many other excellent minor regions, and
                        worldwide, opportunities are ripe and rife. But one region that is often overlooked is Germany’s
                        Mosel. We are all familiar with Egon Muller and J.J. Prum by now, but allow us to introduce you
                        to Dr H. Thanisch, and we will change the way you see Riesling for evermore.
                    </div>

                    <div class="howto-title2">Girl power</div>
                    <div class="howto-text">
                        An historical winery that dates back almost 400 years, Wwe. Dr H. Thanisch is above all a story
                        of strong women. Dr Hugo Thanisch unexpectedly died in 1895, leaving his 30-year old widow (his
                        “witwe”, abbreviated to “wwe”) Katharina, with three small children and an estate to run.
                        However, not one to fail in the face of adversity, Katharina rose to the challenge admirably,
                        and under her tenure, the estate became one of the founding members of the Association of German
                        Quality Wine Producers (VDP) in 1910. The estate has since passed down through 11 generations
                        and today Sofia Thanisch (Katharina and Hugo’s great-granddaughter and 4th female) is at the
                        helm of the 6.5-hectare estate. Sofia’s two daughters look set to continue the tradition.
                    </div>

                    <div class="howto-title2">More Mosel please!</div>
                    <div class="howto-text">
                        Set in prime Mosel terroir, the Wwe Dr. H. Thanisch’s vineyards run along a straight parcel of
                        land adjacent to the river. The proximity to water, along with the south-facing location and
                        superb soil creates the holy trinity for outstanding Riesling grapes. Thus the wines are defined
                        by their unique characteristics: a delicate taste, sophisticated elegance and lightness. Of the
                        eight Riesling wines produced, the most famous is probably from the great “Bernkasteler Doctor”
                        vineyard. These exquisite wines are highly prized by connoisseurs and wine investors alike for
                        their beauty and complexity, making them some of the most sought-after wines of the entire
                        Mosel-Saar-Ruwer region. However, Doctor wines can sometimes be misconstrued. When tasted in
                        their youth, they can seem a little dull, and many critics believe there is no point in opening
                        one up before at least ten years ageing. The irony here is that with such a low production
                        (4,000 bottles annually) and the requisite cellar time, the wine is getting harder and harder to
                        find.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>In 1921, Thanisch made history producing the very first Trockenbeerenauslese on the
                                Mosel. Only made in appropriate years, a bottle such as the 2006 vintage fetching
                                upwards of €660 in 2019.
                            </li>
                            <li>Weinguide Deutschland 2019 named Wwe Dr H Thanisch’s 2017 Bernkasteler Doctor Riesling Spätlese the “Best Riesling Spätlese in the VDP”, awarding 97 points, while Mosel Fine Wines gave this particular vintage 95 points.
                            </li>
                            <li>Due to hail and frost, the 2017 yield was nearly 50% smaller than that of 2016. The
                                combination of higher concentration and lower yields make for a most excellent
                                Bernkasteler Doctor Riesling Auslese. Noting “A great, great Auslese. Drink 2027-2100”
                                John Gilman deemed this particular vintage worth his 96 points.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WweThanisch",
    data() {
        return {
            select: {
                report: 'Wwe. Dr. H. Thanisch, Erben Thanisch',
                src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'
            },
            items: [
                {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
                {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
                {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
                {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
                {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
                {report: 'Weingut Forstmeister Geltz Zilliken', src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'},
                {report: 'Wwe. Dr. H. Thanisch, Erben Thanisch', src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Wwe. Dr. H. Thanisch, Erben Thanisch | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of the wines produced by Weingut Dr. H. Thanisch, Erben Thanisch. Explore the rich heritage and innovative winemaking techniques of this renowned Mosel wine producer. Experience the exceptional flavors and aromas of their Riesling wines and be transported to the heart of the Mosel wine region.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
